/* ===== Подключение компонентов React ===== */

/* ===== Подключение локальной Базы Данных ===== */
import onlimeGsmCards from "../../../data/cardsDb/onlimeGsmCards";

/* ===== Подключение Картинки ===== */
import MapsOnlime from "../../../assets/icons/ui/mapsOnlime.svg";

/* ===== Подключение локальных компонентов ===== */
import Card from "../../ui/Card/CardsSection";

/* ===== Подключение стилей ===== */
import s from "./OnlimeGsm.module.scss";


function OnlimeGsm() {
    return (
        <section className={s.onlimeGsm}>
            <div className={`container ${s.conteiner}`}>
            <div className={s.content}>
                <div className={s.title}>
                    <h2>Прозрачность поставок – онлайн-отслеживание топлива</h2>
                    <p>
                        Все перевозки контролируются через систему спутникового мониторинга ГЛОНАСС. В режиме реального времени мы отслеживаем местоположение транспорта на всём маршруте - от отгрузки на НПЗ до прибытия к вам. Это обеспечивает прозрачность и предсказуемость всего процесса.
                    </p>
                    <h2>Преимущества для клиента:</h2>
                </div>
                <div className={s.cards}>
                    <Card {...onlimeGsmCards} />
                </div>
            </div>
            <div className={s.imgContainer}>
                <img src={MapsOnlime} alt="Картинка в виде карты" />
            </div>
            </div>
        </section>
    )
}

export default OnlimeGsm;



